export default "__VITE_ASSET__UV0CmFTT__"